import React from "react";

export default ({ children }) =>
  <div className="main">
    <div className="content">
      {children}
    </div>
    <style jsx>{`
      .main {
        width: 100vw;
        min-height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .content {
        width: 100%;
        max-width: 944px;
        min-height: 460px;
        margin: 0;
        box-sizing: border-box;
      }
 `}</style>
  </div>;



// WEBPACK FOOTER //
// ./src/components/Main.js